import config from 'config';

import type { User } from '../types/user';
import baseApi from './baseApi';

export interface OnboardingRequest {
  recaptchaToken: string;
  companyName: string;
  userName: string;
  email: string;
  password: string;
  phoneNumber: string;
  companyType: 'car_dealership' | 'insurance_broker';
}

export interface OnboardingResponse {
  message: string;
  user: User;
  company: {
    id: number;
    name: string;
  };
  businessUnit: {
    id: number;
    name: string;
    phoneNumber: string;
    type: string;
  };
}

const onboardingApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    createOnboarding: build.mutation<OnboardingResponse, OnboardingRequest>({
      query: (data) => ({
        // Same-origin (config.authUrl, proxied by server.js): signup starts a session and the
        // response sets the httpOnly refresh-token cookie, which must be first-party.
        url: `${config.authUrl}/onboarding`,
        method: 'POST',
        body: data,
        credentials: 'include',
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useCreateOnboardingMutation } = onboardingApi;
